var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666626 16V8V0H5.90355H11.1405L13.1642 2.02366L15.188 4.04732V10.0237V16H7.92729H0.666626ZM1.86094 14.8057V8V1.19431H6.25427H10.6476L12.3206 2.86726L13.9936 4.54021V9.67295V14.8057H7.92729H1.86094ZM4.62868 5.10584V5.703H7.92726H11.2258V5.10584V4.50869H7.92726H4.62868V5.10584ZM4.62868 7.49447V8.09162H7.92726H11.2258V7.49447V6.89731H7.92726H4.62868V7.49447ZM4.62868 9.93049V10.5276H7.92726H11.2258V9.93049V9.33333H7.92726H4.62868V9.93049ZM4.62868 12.3191V12.9163H7.92726H11.2258V12.3191V11.722H7.92726H4.62868V12.3191Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFile);
export default __webpack_public_path__ + "static/media/icon--file.84c643c363cbe8749f6e32bd5c6d3290.svg";
export { ForwardRef as ReactComponent };